<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="bgcsTKName + '变更'"
      :visible.sync="bgwindow"
      :before-close="handleCloseBindWarnStandard"
      width="1000px"
    >
      <div class="">
        <el-table
          border
          stripe
          :data="gridData"
          :row-style="{ height: 0 + 'px' }"
          :header-cell-style="{
            'text-align': 'center',
            background: '#F2F2F2',
            color: '#333',
          }"
          :cell-style="{ 'text-align': 'center' }"
          style="width: 100%; margin: auto"
        >
          <el-table-column prop="bgnr" label="变更内容" show-overflow-tooltip />
          <el-table-column prop="cjsj" label="变更时间" />
          <el-table-column align="ztLabel" prop="ztLabel" label="状态">
            <template slot-scope="scope">
              <!-- 13:已拒绝 12:同意 11:审批中 -->
              <span
                :style="
                  scope.row.zt == '13'
                    ? 'color:red '
                    : scope.row.zt == '12'
                      ? 'color:#41b883'
                      : 'color:orange'
                "
              >{{ scope.row.ztLabel }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                style="border-radius: 20px !important"
                @click="ckDetail(scope.row)"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 30px"
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="bg_list_obj.size"
          :current-page.sync="bg_list_obj.page"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>

      <div style="width: 100%; text-align: center; margin-top: 30px">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="handleCloseBindWarnStandard"
        >确 定</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        :bgcs-t-k-name="bgcsTKName"
        :dgcs-xq-id="dgcsXqId"
        :xq-type="curRowType"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import bgxqCom from './bgxq/bgxqCom.vue'
import { crkbgList, ykbbbgList, ysbbbgList } from '../assets/js/bgcrk'
export default {
  components: { bgxqCom },
  props: ['bgwindow', 'bgcsTKName', 'cur_type', 'curRowObj'],
  data() {
    return {
      bg_list_obj: {
        page: 1,
        size: 10,
        param: {}
      },
      curRowMes: {},
      curRowType: '',
      total: 0, // 总条数
      gridData: [],
      dialogFormVisible: false,
      dgcsXqId: null // 详情弹框
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.on('bgcsOpen', this.bgcsInfo)
    })
  },
  beforeDestroy() {
    this.$bus.$off('bgcsOpen')
  },
  methods: {
    // 当前页码改变时
    handleCurrentChange(val) {
      this.bg_list_obj.page = val // 当前页
      this.bgcsInfo(this.curRowMes, this.curRowType, this.bg_list_obj)
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.bg_list_obj.size = val // 当前页
      this.bgcsInfo(this.curRowMes, this.curRowType, this.bg_list_obj)
    },
    bgcsInfo(curRow, curType) {
      this.curRowMes = curRow
      this.curRowType = curType
      if (curType == 'ykbb') {
        ykbbbgList(curType, curRow.id, this.bg_list_obj).then((res) => {
          this.gridData = res.data.data.rows
          this.total = res.data.data.total
        })
      } else if (curType == 'ysbb') {
        ysbbbgList(curType, curRow.id, this.bg_list_obj).then((res) => {
          this.gridData = res.data.data.rows
          this.total = res.data.data.total
        })
      } else {
        crkbgList(curType, curRow.id, this.bg_list_obj).then((res) => {
          this.gridData = res.data.data.rows
          this.total = res.data.data.total
        })
      }
    },
    ckDetail(data) {
      this.dgcsXqId = data.id
      this.dialogFormVisible = true
    },
    // 关闭绑定气体标准弹窗
    handleCloseBindWarnStandard() {
      this.$emit('closeBindWarnStandard')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  text-align: center;
}
</style>
